import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { formatNumber, formatMoney } from 'accounting-js';

import AssetsDepreciationValues from 'components/assets/depreciation/AssetsDepreciationValues';
import { defaultFormat } from 'moment';

class AssetesDepreciationDetail extends PureComponent {
  static propTypes = {
    depreciation: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  renderDepreciationRows = () => {
    let acumulado = 0;
    return !this.props.depreciation || !this.props.depreciation.yearly
      ? null
      : Object.keys(this.props.depreciation.yearly)
          .sort((a, b) => a < b)
          .map((year, index) => {
            const dep = this.props.depreciation.yearly[year];
            acumulado += dep.factors.countMonthDep;
            return (
              <tr key={index}>
                <td className="text-center">{year}</td>
                <td className="text-center">
                  {this.props.t(`months.${dep.factors.firstMonth}`)}
                  {' - '}
                  {this.props.t(`months.${dep.factors.lastMonth}`)}
                </td>
                <td className="text-center">{formatNumber(dep.factors.countMonthDep)}</td>
                <td className="text-center">{formatNumber(acumulado || 0)}</td>
                <td className="text-center">
                  {formatNumber(this.props.depreciation.totalLifeMonths)}
                </td>
                <td
                  className={classnames('text-center', {
                    'table-warning': dep.factors.warning,
                    'table-success': !dep.factors.warning,
                  })}
                >
                  {formatNumber(dep.factors.factor || 0, { precision: 4 })}
                </td>
                <td className="text-center">{formatMoney(this.props.depreciation.depMonthly)}</td>
                <td className="text-right">{formatMoney(dep.depreciation)}</td>
                <td className="text-center">{formatNumber(dep.depreciationPercentage || 0)} %</td>
                <td className="text-right">{formatMoney(dep.acummDepreciation || 0)}</td>
                <td className="text-center">
                  {formatNumber(dep.acummDepreciationPercentage || 0)} %
                </td>
                <td className="text-right table-info">{formatMoney(dep.depreciable || 0)}</td>
              </tr>
            );
          });
  };

  render = () => (
    <div className="col-12 bbottom mb-3 mt-3">
      <AssetsDepreciationValues depreciation={this.props.depreciation} title={this.props.title} />
      <div className="row">
        <div className="col-sm-12">
          <table className="table table-striped table-hover table-sm">
            <thead>
              <tr>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.year')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.period')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.monthsDepExercise')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.totalMonthsDepExercise')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.totalMonthsToDep')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.factor')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.depMonthly')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.depPeriod')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.percentajeDepPeriod')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.depAccumulated')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.percentajeDepAccumulated')}
                </th>
                <th className="text-center">
                  {this.props.t('assets.tablesDepreciationColums.valueToDepreciate')}
                </th>
              </tr>
            </thead>
            <tbody>{this.renderDepreciationRows()}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default translate()(AssetesDepreciationDetail);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationDetail.js